// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"888454dd","16":"1bc8b310","215":"506b3e04","320":"d0751333","888":"0292b062"}[chunkId] + ".chunk.js";
};